import React from 'react';
import PropTypes from 'prop-types';
// form
import {useFormContext, Controller} from 'react-hook-form';
// @mui
import {TextField} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {DateTimePicker} from '@mui/x-date-pickers/DateTimePicker';
import {alpha} from '@mui/material/styles';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import AdapterJalali from '@date-io/date-fns-jalali';
import moment from "jalali-moment";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

// ----------------------------------------------------------------------

RHFDateTimePicker.propTypes = {
    name: PropTypes.string,
};

export default function RHFDateTimePicker({name, ...other}) {
    const theme = useTheme();
    const {control, getValues, setValue} = useFormContext();

    const customIcon = () => {
        return (
            <div
                style={{
                    background: alpha(theme.palette.primary.light, 0.15),
                    padding: 3,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    borderRadius: 10,
                }}
            >
               <CalendarMonthIcon sx={{ color: theme.palette.primary.main, borderRadius: 1 }} />
            </div>
        );
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({field, fieldState: {error}}) => (
                <LocalizationProvider dateAdapter={AdapterJalali}>
                    <DateTimePicker
                        {...other}
                        mask={'____/__/__ __:__'}
                        ampm={false}
                        value={getValues(name) ?? null}
                        onChange={(e) => {
                            setValue(name, moment(e, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DDTHH:mm:ss.sssZ'));
                        }}
                        components={{
                            OpenPickerIcon: customIcon,
                        }}
                        sx={{
                            '&.MuiPickersToolbar-root': {direction:'rtl'},
                           }}
                        renderInput={(params) => <TextField sx={{textAlign:'left',zIndex:0}} fullWidth {...params} error={!!error}
                                                            helperText={error?.message} />}
                    />
                </LocalizationProvider>
            )}
        />
    );
}
